import { useLayoutEffect } from 'react';

let lockCount = 0;
export default function useBodyScrollLock({ condition, mobileOnly }) {
  useLayoutEffect(() => {
    const shouldLock = condition && (!mobileOnly || (mobileOnly && window.innerWidth <= 768));

    if (shouldLock) {
      if (lockCount === 0) {
        document.body.style.overflow = 'hidden';
      }
      lockCount += 1;
    }

    return () => {
      if (shouldLock) {
        lockCount -= 1;
        if (lockCount === 0) {
          document.body.style.overflow = 'auto';
        }
      }
    };
  }, [condition, mobileOnly]);
}
